import { createAppSlice } from "../../../store/createAppSlice";

interface AuthState {
  isAuthenticated: boolean;
  isInitialized: boolean;
  userId: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  isInitialized: false,
  userId: null,
};

export const authSlice = createAppSlice({
  name: "auth",
  initialState,
  reducers: (create) => ({
    setAuthState: create.reducer<{
      isAuthenticated: boolean;
      userId: string | null;
    }>((state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.userId = action.payload.userId;
      state.isInitialized = true;
    }),
  }),

  selectors: {
    getIsAuthenticated: (state) => state.isAuthenticated,
    getIsInitialized: (state) => state.isInitialized,
    getUserId: (state) => state.userId,
  },
});

export const { actions, selectors } = authSlice;
